import { selectCcamCodeById } from '../reducers/ccamCodes.reducer'
import { selectCommonCareById } from '../reducers/commonCares.reducer'
import { selectType } from '../reducers/simulation.reducer'
import { AppState } from '../store'

export const getCcamCategoryLabels = (state: AppState) =>
  state.ccamCategoryLabels

export const getCcamCodesByCategory = (state: AppState) => ({
  loading: state.ccamCodes.loading,
  value: Array.from(new Set(state.ccamCodes.value.map(code => code.code))),
})

export const getCares =
  (code: string, categoryLabel: string) => (state: AppState) => {
    return state.ccamCodes.value.filter(
      ccamCode =>
        ccamCode.code === code &&
        (ccamCode.categoryLabel === categoryLabel ||
          ccamCode.categoryLabel === null)
    )
  }

export const selectSelectedCareById = (id: string) => (state: AppState) => {
  if (selectType(state) === 'ccam_code') {
    return selectCcamCodeById(id)(state)
  } else {
    return selectCommonCareById(id)(state)
  }
}
